import { useState, useEffect } from 'react';
import { Link, useLocation,useNavigate } from 'react-router-dom';
import { motion,AnimatePresence  } from 'framer-motion';
import { ShoppingBag, Menu, X, User,LayoutDashboard   } from 'lucide-react';
import { useCart } from '../../Context/CartContext';
import { useAuth } from '../../auth/AuthContext';
import { getCategories } from "../../services/categoryService";
const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [openCategory, setOpenCategory] = useState(null);
  const [openSubcategory, setOpenSubcategory] = useState(null);
  const [hoverTimeout, setHoverTimeout] = useState(null);
  const [isScrolled, setIsScrolled] = useState(false);
  const [categories, setCategories] = useState([null]);
  const [showCategories, setShowCategories] = useState(false);
  const { getCartCount } = useCart();
  const location = useLocation();
  const navigate = useNavigate();
  const { isLoggedIn, userRole } = useAuth();
  const toggleMenu = () => setIsOpen(!isOpen);
  const closeMenu = () => setIsOpen(false);
  const handleCategoryEnter = () => {
    clearTimeout(hoverTimeout);
    setOpenCategory(true);
  };

  const handleCategoryLeave = () => {
    const timeout = setTimeout(() => {
      setOpenCategory(false);
      setOpenSubcategory(null);
    }, 200); // 300ms gecikme
    setHoverTimeout(timeout);
  };

  const handleSubcategoryEnter = (categoryId) => {
    clearTimeout(hoverTimeout);
    setOpenSubcategory(categoryId);
  };
  const menuVariants = {
    hidden: { opacity: 0, y: -10 },
    visible: { 
      opacity: 1, 
      y: 0,
      transition: {
        duration: 0.2,
        ease: "easeOut"
      }
    },
    exit: { 
      opacity: 0, 
      y: -10,
      transition: {
        duration: 0.15,
        ease: "easeIn"
      }
    }
  };
  const submenuVariants = {
    hidden: { opacity: 0, x: -10 },
    visible: { 
      opacity: 1, 
      x: 0,
      transition: {
        duration: 0.2,
        ease: "easeOut"
      }
    },
    exit: { 
      opacity: 0, 
      x: -10,
      transition: {
        duration: 0.15,
        ease: "easeIn"
      }
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await getCategories();
        setCategories(data);

      } catch (error) {
        // hata zaten serviste loglanıyor, burada kullanıcıya gösterilebilir
      }
    };

    fetchData();
  }, []);
  
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleAccountClick = () => {
    if (isLoggedIn) {
      navigate('/account');
    } else {
      navigate('/login');
    }
  };
  const handleAdminPanelClick = () => {
    navigate("/admin");
  };
  useEffect(() => {
    closeMenu();
  }, [location]);

  return (
    <header 
      className={`sticky top-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md py-3' : 'bg-secondary-light py-5'
      }`}
    >
      <div className="container-custom flex items-center justify-between">
        <Link to="/" className="z-50">
        <div className="flex items-center space-x-2">
  <img
    src="/logo.png"
    alt="Logo"
    className="w-10 h-10 object-contain"
  />
  <span className="font-semibold text-lg">Çelik Ticaret</span>
</div>  
        </Link>

        {/* Desktop Menu */}
        <nav className="hidden md:flex items-center space-x-8">
          <Link to="/" className="font-medium text-gray-dark hover:text-primary transition-colors">
            Ana Sayfa
          </Link>
 {/* Kategoriler Dropdown */}
<div className="relative group" onMouseEnter={handleCategoryEnter} onMouseLeave={handleCategoryLeave}>
  <button className="font-medium text-gray-dark hover:text-primary transition-colors flex items-center">
    Kategoriler
    <motion.span animate={{ rotate: openCategory ? 180 : 0 }} transition={{ duration: 0.2 }}>
      <svg className="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
      </svg>
    </motion.span>
  </button>

  <AnimatePresence>
    {openCategory && (
      <motion.div
        className="absolute left-0 mt-2 w-56 bg-white rounded-md shadow-lg z-10 border border-gray-100"
        variants={menuVariants}
        initial="hidden"
        animate="visible"
        exit="exit"
      >
        <div className="py-1">
          {categories.map((category) => (
            <div
              key={category.id}
              className="relative group/sub"
              onMouseEnter={() => handleSubcategoryEnter(category.id)}
              onMouseLeave={() => setOpenSubcategory(null)}
            >
              <button className="w-full text-left px-4 py-2 hover:bg-gray-50 flex justify-between items-center">
                <span>{category.name}</span>
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </button>

              <AnimatePresence>
                {openSubcategory === category.id && (
                  <motion.div
                    className="absolute left-full top-0 ml-1 w-56 bg-white rounded-md shadow-lg z-20 border border-gray-100"
                    variants={submenuVariants}
                    initial="hidden"
                    animate="visible"
                    exit="exit"
                  >
                    <div className="py-1">
                      {category.subCategories.map((subcategory) => (
                        <Link
                          key={subcategory.id}
                          to={`/products/${category.id}/${subcategory.id}`}
                          className="block px-4 py-2 hover:bg-gray-50"
                        >
                          {subcategory.name}
                        </Link>
                      ))}
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          ))}
        </div>
      </motion.div>
    )}
  </AnimatePresence>
</div>

          <Link to="/contact" className="font-medium text-gray-dark hover:text-primary transition-colors">
            İletişim
          </Link>
        </nav>

        {/* Icons */}
        <div className="flex items-center space-x-4 z-50">
        {isLoggedIn && userRole === "admin" && (
        <button
          onClick={handleAdminPanelClick}
          className="text-gray-dark hover:text-primary transition-colors"
          title="Admin Panel"
        >
          <LayoutDashboard size={24} />
        </button>
      )}
        <button
            onClick={handleAccountClick}
            className="text-gray-dark hover:text-primary transition-colors"
          >
            <User size={24} />
          </button>
          <Link to="/cart" className="relative text-gray-dark hover:text-primary transition-colors">
            <ShoppingBag size={24} />
            {getCartCount() > 0 && (
              <motion.span 
                initial={{ scale: 0 }}
                animate={{ scale: 1 }}
                className="absolute -top-2 -right-2 bg-primary text-white rounded-full w-5 h-5 flex items-center justify-center text-xs"
              >
                {getCartCount()}
              </motion.span>
            )}
          </Link>
          
          {/* Mobile menu button */}
          <button 
            className="md:hidden text-gray-dark focus:outline-none" 
            onClick={toggleMenu}
            aria-label="Toggle menu"
          >
            {isOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isOpen && (
          <motion.div 
            initial={{ opacity: 0, x: '100%' }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: '100%' }}
            transition={{ duration: 0.3 }}
            className="fixed inset-0 bg-white z-40 flex flex-col items-center justify-center"
          >
            <nav className="flex flex-col items-center space-y-8">
              <Link to="/" className="text-2xl font-medium text-gray-dark hover:text-primary transition-colors">
                Ana Sayfa
              </Link>
              <div className="w-full">
  <button
    onClick={() => setShowCategories((prev) => !prev)}
    className="text-2xl font-medium text-gray-dark mb-2 flex items-center justify-between w-full"
  >
    Kategoriler
    <svg
      className={`w-5 h-5 transform transition-transform ${showCategories ? "rotate-90" : ""}`}
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
    </svg>
  </button>

  {showCategories && (
    <div className="space-y-2">
      {categories.map((category) => (
        <div key={category.id} className="w-full">
          <button
            onClick={() =>
              setOpenSubcategory((prev) => (prev === category.id ? null : category.id))
            }
            className="w-full flex justify-between items-center px-4 py-2"
          >
            <span>{category.name}</span>
            <svg
              className={`w-4 h-4 transform transition-transform ${openSubcategory === category.id ? "rotate-90" : ""}`}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </button>

          {openSubcategory === category.id && (
            <div className="ml-4 mt-1 space-y-1">
              {category.subCategories.map((subcategory) => (
                <Link
                  key={subcategory.id}
                  to={`/products/${category.id}/${subcategory.id}`}
                  className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 rounded"
                >
                  {subcategory.name}
                </Link>
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  )}
</div>
              <Link to="/contact" className="text-2xl font-medium text-gray-dark hover:text-primary transition-colors">
                İletişim
              </Link>
            </nav>
          </motion.div>
        )}
      </div>
    </header>
  );
};

export default Header;